<script lang="ts">
  import { browser } from '$app/env';
  import { shadow } from '~/utils/scrollShadow';

  const props = $props();
</script>

{#if browser}
  <div use:shadow class="scroll-shadow">
    {@render props.children()}
  </div>
{:else}
  <div class="scroll-shadow">
    {@render props.children()}
  </div>
{/if}

<style lang="scss">
  .scroll-shadow {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    flex-direction: column;
    display: flex;
    --scroll-shadow-size: 14;
    --scroll-shadow-top: radial-gradient(
      farthest-side at 50% 0%,
      var(--shadow-color),
      #0000
    );
    --scroll-shadow-bottom: radial-gradient(
      farthest-side at 50% 100%,
      var(--shadow-color),
      #0000
    );
    --scroll-shadow-left: radial-gradient(
      farthest-side at 0%,
      var(--shadow-color),
      #0000
    );
    --scroll-shadow-right: radial-gradient(
      farthest-side at 100%,
      var(--shadow-color),
      #0000
    );
    --shadow-color: #0003;
    :global(html.dark-mode) & {
      --shadow-color: #0006;
    }
  }
  .scroll-shadow::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    --m: var(--scroll-shadow-size, 14) * 1px;
    background:
      var(--scroll-shadow-top) top / 100% min(var(--t), var(--m)),
      var(--scroll-shadow-bottom) bottom / 100% min(var(--b), var(--m)),
      var(--scroll-shadow-left) left / min(var(--l), var(--m)) 100%,
      var(--scroll-shadow-right) right / min(var(--r), var(--m)) 100%;
    background-repeat: no-repeat;
  }
</style>
